
var rmsApiProxyRetry = require('../../api/rmsApiProxyRetry.js');
var logger = require('../../logger/logger');

module.exports.performRefund = function(sale, amount)
{
    var refundRequest = {};
    refundRequest.processor = "Flipdish";
    refundRequest.storefrontId =  sale.storefrontId;
    refundRequest.orderId = sale.tag;
    refundRequest.amount = amount * 1;

    var resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/refunds`;
    return rmsApiProxyRetry.post(resource, refundRequest)
            .then(result =>
            {
                return Promise.resolve(result);
            }, error =>
            {
                logger.warn(`Error occurred while executing a refund`, {}, error, "Flipdish");
                return Promise.reject(error);
            });
}